module.exports = __webpack_public_path__ + "img/client-16.6af79387.png";